import { useEffect, useState } from "react";
import UniversityService from "../services/UniversityService";
import { useQuery } from "@tanstack/react-query";
import SectionContainer from "./SectionContainer";
import { Col, Container, Row } from "reactstrap";
import BreadCrumb from "../component/BreadCrumb/BreadCrumb";
import { imageBaseApi } from "../services/imageBaseApi";
import arrow from "../assets/kangaroo/arrow-cropped.svg";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import CountryIntelSectionService from "../services/CountryIntelSectionService";
import Destinationcountry from "../services/Destinationcountry";

const Professional = ({ slug }) => {
  const [selectedItem, setSelectedItem] = useState(false);
  const [selectedItem2, setSelectedItem2] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [visibleCount, setVisibleCount] = useState(
    window.innerWidth < 768 ? 8 : 24,
  );
  const [countryData, setCountryData] = useState([]);
  console.log("🚀 ~ Professional ~ countryData:", countryData);
  const fetchCountryData = async () => {
    try {
      const response = await Destinationcountry.getList();
      const australiaData = response.find((item) => item.slug === "australia");
      setCountryData(australiaData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCountryData();
  }, [countryData?.id]);

  const fetchData = async () => {
    const response = await UniversityService.getList(countryData?.id);
    return response;
  };

  const {
    isPending,
    error,
    data: universityData,
  } = useQuery({
    queryKey: ["university", countryData?.id],
    queryFn: fetchData,
  });
  const isOnshoreData = universityData?.filter(
    (item) => item.isOnshore === true,
  );
  const handleLoadMore = () => {
    if (visibleCount >= isOnshoreData?.length) {
      setVisibleCount(24);
    } else {
      // const newCount = visibleCount + 15;
      setVisibleCount(isOnshoreData?.length || 0);
    }
  };

  return (
    <>
      <Container fluid className="p-0">
        <Row>
          <Col>
            <h1 className="font-level-4 mb-5">INSTITUTIONS WE REPRESENT</h1>
          </Col>
        </Row>
        <hr style={{ marginBottom: "30px" }} className="line mt-2 " />

        {/* Search Filters */}

        {/* University Grid */}
        <Row className="gy-4 ">
          {isOnshoreData
            ?.filter((item) => (slug ? item?.slug !== slug : true))
            ?.map((item, index) => (
              <Col
                xl={3}
                lg={4}
                md={6}
                sm={6}
                xs={12}
                key={item?.slug || index}
                className="p-2 d-flex justify-content-lg-between justify-content-center"
              >
                <Link to={`/institution/${item?.slug}`}>
                  <motion.div
                    className="d-flex justify-content-center border rounded align-items-center"
                    style={{
                      height: "126px",
                      width: "100%",
                      maxWidth: "235px",
                    }}
                    whileHover={{ scale: 1.15 }}
                    transition={{
                      duration: 0.3,
                      ease: "easeInOut",
                    }}
                  >
                    <img
                      src={imageBaseApi + item?.logoMedia?.url}
                      alt={item?.name || "University logo"}
                      style={{
                        objectFit: "contain",
                        height: "100%",
                        width: "100%",
                      }}
                      className="rounded"
                    />
                  </motion.div>
                </Link>
              </Col>
            ))}
        </Row>

        {/* Load More Button */}
      </Container>
    </>
  );
};

export default Professional;
